// extracted by mini-css-extract-plugin
export default {"groupHeading":"styles-module__groupHeading--BbDLO","searchSpinner":"styles-module__searchSpinner--vQkfE"};